import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Button, Space, Tag, Modal, message } from 'antd';
import { NotificationOutlined, CheckOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';

const COLORS = { urgent: 'error', important: 'warning', normal: 'info' };
const LABELS = { urgent: 'Zaroori', important: 'Important', normal: 'Notice' };

// Notice board — jab tak staff "Padh liya" na kare, tab tak upar dikhta rahega.
export default function NoticeBanner() {
  const [notices, setNotices] = useState([]);
  const [popup, setPopup] = useState(null);

  const load = useCallback(() => {
    api.get('/notices/my')
      .then(r => setNotices(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  useEffect(() => {
    const urgent = notices.find(n => n.importance === 'urgent');
    if (!urgent) return;
    const key = `notice-popup-${urgent.id}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    setPopup(urgent);
  }, [notices]);

  const markRead = async (id) => {
    try {
      await api.post(`/notices/${id}/read`);
      setNotices(list => list.filter(n => n.id !== id));
      if (popup && popup.id === id) setPopup(null);
    } catch {
      message.error('Mark read nahi hua — dobara try karo');
    }
  };

  if (notices.length === 0) return null;

  return (
    <>
      <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
        {notices.map(n => (
          <Alert
            key={n.id}
            type={COLORS[n.importance] || 'info'}
            showIcon
            icon={<NotificationOutlined />}
            style={{ borderRadius: 10 }}
            message={
              <Space wrap>
                <b style={{ fontSize: 15 }}>{n.title || 'Notice'}</b>
                <Tag color={n.importance === 'urgent' ? 'red' : n.importance === 'important' ? 'orange' : 'blue'}>
                  {LABELS[n.importance] || 'Notice'}
                </Tag>
                <span style={{ color: '#888', fontSize: 12 }}>
                  {n.created_by_name ? `${n.created_by_name} · ` : ''}{dayjs(n.created_at).format('DD MMM, hh:mm A')}
                </span>
              </Space>
            }
            description={
              <div>
                <div style={{ whiteSpace: 'pre-wrap', fontSize: 15 }}>{n.body}</div>
                {n.link && (
                  <div style={{ marginTop: 6 }}>
                    <a href={n.link} target="_blank" rel="noopener noreferrer">{n.link}</a>
                  </div>
                )}
                <Button
                  type="primary"
                  size="small"
                  icon={<CheckOutlined />}
                  style={{ marginTop: 10 }}
                  onClick={() => markRead(n.id)}
                >
                  Padh liya
                </Button>
              </div>
            }
          />
        ))}
      </Space>

      <Modal
        open={!!popup}
        onCancel={() => setPopup(null)}
        title={<Space><NotificationOutlined style={{ color: '#cf1322' }} /> {popup?.title || 'Zaroori Notice'}</Space>}
        footer={
          <Button type="primary" icon={<CheckOutlined />} onClick={() => popup && markRead(popup.id)}>
            Padh liya
          </Button>
        }
      >
        <div style={{ whiteSpace: 'pre-wrap', fontSize: 16 }}>{popup?.body}</div>
        {popup?.link && (
          <div style={{ marginTop: 10 }}>
            <a href={popup.link} target="_blank" rel="noopener noreferrer">{popup.link}</a>
          </div>
        )}
      </Modal>
    </>
  );
}
